/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-form-field[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]     .mat-form-field-underline{position:initial}[_nghost-%COMP%]     .mat-form-field-subscript-wrapper{position:initial;overflow:visible}"];
export { styles as styles };
